import { defineStore } from 'pinia'
import { ref } from 'vue'
import { fetchProfile, saveProfile } from '@/api/paymentProfiles'
import { IPaymentProfileAttributes } from '@/interfaces/paymentProfiles'

export const usePaymentProfilesStore = defineStore('paymentProfiles', () => {
  const items = ref<{ [systemSid: string]: IPaymentProfileAttributes }>({})

  const FetchItem = async (sid: string) => {
    const response = await fetchProfile(sid)
    items.value[sid] = response.data.attributes
  }

  const SaveItem = async (params: IPaymentProfileAttributes) => {
    const response = await saveProfile(params)
    return response
  }

  return {
    items,
    SaveItem,
    FetchItem
  }
})
